export default {

  // 新增原料入厂验收
  insertPaMaterialInspection: '/ygsjzs/paMaterialInspection/insertPaMaterialInspection',
  // 修改原料入厂验收
  updatePaMaterialInspection: '/ygsjzs/paMaterialInspection/updatePaMaterialInspection',
  // 删除原料入厂验收
  deletePaMaterialInspection: '/ygsjzs/paMaterialInspection/deletePaMaterialInspection',

  // 查询原料入厂验收详情
  selectPaMaterialInspectionByInspectId: '/ygsjzs/paMaterialInspection/selectPaMaterialInspectionByInspectId',

  // 分页查询原料入厂验收列表
  selectPaMaterialInspectionByPage: '/ygsjzs/paMaterialInspection/selectPaMaterialInspectionByPage',
  // 导出原料入厂验收
  exportPaMaterialInspection: '/ygsjzs/paMaterialInspection/exportPaMaterialInspection'
}
